import { Pipe, PipeTransform } from '@angular/core';
import { WordRect } from '../page-overlay/model';
import { OcrSearchResult } from '../model/document-searcher.interface';

@Pipe({
  name: 'toWordRect',
})
export class OcrSearchResultToWordRectPipe implements PipeTransform {
  transform(box: OcrSearchResult | undefined): WordRect {
    if (box === undefined) return { x: [0, 0], y: [0, 0] };
    return {
      x: [box.wordRectLeft, box.wordRectLeft + box.wordRectWidth],
      y: [box.wordRectTop, box.wordRectTop + box.wordRectHeight],
    };
  }
}
